import React, { useState } from "react";
import HomeIcon from "@mui/icons-material/Home";
import AddIcon from "@mui/icons-material/Add";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CategoryIcon from "@mui/icons-material/Category";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { Link } from "react-router";
import { useNavigate } from "react-router";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ViewListIcon from "@mui/icons-material/ViewList";
import SavingsIcon from "@mui/icons-material/Savings";
import BallotIcon from "@mui/icons-material/Ballot";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import ConfirmModal from "../../components/ConfirmModal";
import SettingsIcon from "@mui/icons-material/Settings";

function SideBar() {
  const [isDropdown, setDropdown] = useState(false);
  const [isSettingDropdown, setSettingDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleQuit = () => {
    setIsModalOpen(true); // Open the confirmation modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const navigate = new useNavigate();
  const handleConfirmQuit = () => {
    sessionStorage.clear();

    navigate("/login");
  };
  const handleDropdown = () => {
    setDropdown(!isDropdown);
  };

  return (
    <div className="w-2/12  flex gap-2   flex-col px-4 pt-4 lg:pt-4 overflow-y-scroll pb-20 bg-gray-200">
      <Link
        to="/manager"
        className="flex flex-row gap-2 hover:bg-gray-300 p-2 items-center"
      >
        <HomeIcon />
        <span className="text-lg font-medium hidden lg:block">Dashboard</span>
      </Link>
      <Link
        to="products"
        className="flex flex-row hover:bg-gray-300 p-2  gap-2 items-center"
      >
        <ViewListIcon />
        <span className="text-lg font-medium hidden lg:block">Products</span>
      </Link>
      <Link
        to="addproduct"
        className="flex flex-row hover:bg-gray-300 p-2  gap-2 items-center"
      >
        <AddIcon />
        <span className="text-lg font-medium hidden lg:block">
          Add Products
        </span>
      </Link>
      <div>
        <button
          onClick={() => handleDropdown()}
          className="flex flex-row gap-2 hover:bg-gray-300 p-2 items-center"
        >
          <CategoryIcon />
          <span className="text-lg font-medium hidden lg:block">Category</span>
          {isDropdown === false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        </button>
        {isDropdown && (
          <div className="pl-4">
            <Link
              to="category"
              className="flex flex-row gap-2 hover:bg-gray-300 p-2 items-center"
            >
              <BallotIcon />
              <span className="text-lg font-medium hidden lg:block">
                Category
              </span>
            </Link>
            <Link
              to="subcategory"
              className="flex flex-row gap-2 hover:bg-gray-300 p-2 items-center"
            >
              <ClearAllIcon />
              <span className="text-lg font-medium hidden lg:block">
                Sub-Category
              </span>
            </Link>
          </div>
        )}
      </div>

      <Link
        to="lowstock"
        className="flex flex-row gap-2 hover:bg-gray-300 p-2 items-center"
      >
        <ShowChartIcon />
        <span className="text-lg font-medium hidden lg:block">Low Stock</span>
      </Link>
      <Link
        to="sales"
        className="flex flex-row gap-2 hover:bg-gray-300 p-2 items-center"
      >
        <MonetizationOnIcon />
        <span className="text-lg font-medium hidden lg:block">Sales</span>
      </Link>
      <Link
        to="customers"
        className="flex flex-row gap-2 hover:bg-gray-300 p-2 items-center"
      >
        <PermIdentityIcon />
        <span className="text-lg font-medium hidden lg:block">Customers</span>
      </Link>

      <Link
        to="users"
        className="flex flex-row gap-2 hover:bg-gray-300 p-2 items-center"
      >
        <PeopleOutlineIcon />
        <span className="text-lg font-medium hidden lg:block">Users</span>
      </Link>
      <button onClick={handleQuit} className=" flex ">
        <ExitToAppIcon className="text-red-500 " sx={{ fontSize: 40 }} />
        <h3 className="text-2xl hidden lg:block">sign out</h3>
      </button>

      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmQuit}
        text1="Confirm Quit"
        text2="Are you sure you want to quit the app?"
      />
    </div>
  );
}

export default SideBar;
